export type DeclaredNodePayload = {
	readonly uuid: string;
	readonly path: string;
	readonly name: string;
	readonly isList: boolean;
	readonly order: number;
};

// `type` is the library's raw field type string (e.g. `'text'`), not yet resolved against
// `TemplateFieldType` — the sidebar that reads this action resolves the label itself.
export type DeclaredFieldPayload = {
	readonly uuid: string;
	readonly path: string;
	readonly label: string;
	readonly type: string;
	readonly isRequired: boolean;
	readonly order: number;
};

// `status` mirrors the server's decision rule: no library anomaly is ever surfaced, only these four cases.
export type DocumentTemplateFileDescribedPayload =
	| {
			readonly status: 'declared';
			readonly fieldCount: number;
			readonly nodes: DeclaredNodePayload[];
			readonly fields: DeclaredFieldPayload[];
	  }
	| { readonly status: 'unreadable' }
	| { readonly status: 'malformed' }
	| { readonly status: 'undeclared' };

export type DocumentTemplateFileDescribedAction = {
	type: 'DOCUMENT_TEMPLATE_FILE_DESCRIBED';
	payload: DocumentTemplateFileDescribedPayload;
};

export default (payload: DocumentTemplateFileDescribedPayload): DocumentTemplateFileDescribedAction => ({
	type: 'DOCUMENT_TEMPLATE_FILE_DESCRIBED',
	payload,
});
